// Module
var code = "<div class=\"field-row from-control-container agent-selector-container\"> <div class=\"head\"> <label>Connecting Node</label> </div> <div class=\"body\"> <div> <div class=\"agent-selector\"></div> </div> </div> </div> <div class=\"table-selector\"></div> ";
// Exports
export default code;